import { useMemo } from 'react';
/**
 * @type {WeakMap<any, number>}
 */

var uniqueIdMap = new WeakMap();
/**
 * Creates a new id for a given object.
 *
 * @param {unknown} object Object reference to create an id for.
 * @return {number}
 */

function createId(object) {
  var instances = uniqueIdMap.get(object) || 0;
  uniqueIdMap.set(object, instances + 1);
  return instances;
}
/**
 * Provides a unique instance ID.
 *
 * @param {unknown} object Object reference to create an id for.
 * @param {string} prefix Prefix for the unique id.
 * @param {string} preferredId Default ID to use.
 * @return {string | number}
 */


export function useUniqueId(object, prefix, preferredId) {
  if (preferredId === void 0) {
    preferredId = '';
  }

  return useMemo(function () {
    if (preferredId) return preferredId;
    var id = createId(object);
    return prefix ? prefix + "-" + id : id;
  }, [object, preferredId, prefix]);
}